import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { ButtonComponent } from '@shared/components/button';
import { ModalFooterDirective, ModalShellComponent } from '@shared/components/modal';
import { SensSynchronisation } from '../../liste-clients.interface';

// Dialog "dumb" : demande dans quel sens synchroniser le client (options + connection string)
@Component({
  selector: 'app-dialog-sens-synchronisation',
  imports: [ModalShellComponent, ModalFooterDirective, ButtonComponent],
  templateUrl: './dialog-sens-synchronisation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './dialog-sens-synchronisation.component.scss',
})
export class DialogSensSynchronisationComponent {
  readonly dialogRef = inject<DialogRef<SensSynchronisation, DialogSensSynchronisationComponent>>(DialogRef);

  annuler(): void {
    this.dialogRef.close();
  }

  choisir(sens: SensSynchronisation) {
    this.dialogRef.close(sens);
  }
}
